{
  "salon-details-header": {
    "buttons": {
      "link-copied": "LINK KOPIERT",
      "share": "TEILEN",
      "visit-virtually": "DEN SALON VIRTUELL BESUCHEN"
    }
  }
}
